export default {
  title: 'Bookingtilgængelighed',
};
